// removed by extract-text-webpack-plugin
module.exports = {"load-data-pane":"load-data-pane__load-data-pane___27Fu9"};